module.exports = __webpack_public_path__ + "static/media/machine-occupied.57bf1ddc.svg";